// extracted by mini-css-extract-plugin
export default {"NavigationContainer":"Navigation_NavigationContainer__bOcYR","Navigation":"Navigation_Navigation__T0WVT"};